import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title } from '../../components/Shared/TitleSuccess';
import { ActionTypes } from '../../utils/enums';
import { setExitingCardProps, getExitingCardProps } from '../Widget/actions';

const TitleComponent = () => <Title>Thanks! You’re not quite done yet.</Title>;

TitleComponent.propTypes = {};

const VoteRegistrationSuccessFinal = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={<TitleComponent />}
            hideSubtitle={true}
            beforeAdvancing={() => {
                props.setExitingCardProps('voteRegistration', props, props.exitingAction);
            }}
            {...props}
        />
    </TransitionContainerNoExit>
);

VoteRegistrationSuccessFinal.propTypes = {
    exitingAction: PropTypes.object.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    thankYouText: PropTypes.string.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/successFinal'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            exitingAction: state.widget.activeAction,
            thankYouText: `Your voter <a target="_blank" href="${
                state.voteRegistration.completeVoteRegistration.pdfUrl
            }">registration forms are complete</a>, but you still need to sign and mail them to the address located on the form. We've also emailed the form to the address you gave us so you have access to it later.`
        };
    },
    { setExitingCardProps },
    null,
    {
        areStatesEqual: (next, prev) => {
            if (next.widget.activeAction.type !== ActionTypes.VoteRegistration)
                return true;

            return next === prev;
        }
    }
)(VoteRegistrationSuccessFinal);
